import React from "react";

const PRIMARY = "#48A6A7";

export default function Privacy() {
  return (
    <main className="w-full text-terakkiInk">
      <section className="max-w-6xl mx-auto px-6  py-6">
        <article className="bg-white/85 border border-white/80 rounded-3xl p-6 md:p-8 backdrop-blur-xl shadow-2xl shadow-terakkiPrimaryDark/15 space-y-8 divide-y divide-terakkiBorder">
          <div className="grid grid-cols-1 md:grid-cols-[1.05fr_0.95fr] gap-6 items-start">
            <div className="space-y-3">
              <div className="inline-flex items-center gap-2 rounded-full border border-terakkiBorder bg-terakkiBrandMist/60 px-4 py-2 text-sm text-terakkiPrimaryDark">
                <span
                  className="w-2 h-2 rounded-full"
                  style={{ background: PRIMARY }}
                />
                Gizlilik İlkeleri • Adım Adım Terakki
              </div>
              <div className="space-y-2">
                <h1 className="text-2xl md:text-3xl font-bold text-terakkiInk">
                  Gizlilik Sözleşmesi
                </h1>
                <p className="text-terakkiInk/80">
                  Bu metin, Terakki platformunu kullanırken kişisel
                  verilerinizin hangi amaçlarla işlendiğini ve nasıl korunduğunu
                  açıklar.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {[
                {
                  title: "Veri minimizasyonu",
                  desc: "Sadece hizmet için gereken verileri toplarız.",
                },
                {
                  title: "Erişim kontrolü",
                  desc: "Yetkisiz erişime karşı güvenlik önlemleri uygularız.",
                },
                {
                  title: "Şeffaflık",
                  desc: "Toplama ve kullanım amaçlarını açıkça paylaşırız.",
                },
                {
                  title: "Haklarınıza saygı",
                  desc: "KVKK kapsamındaki tüm haklarınıza saygı duyuyoruz.",
                },
              ].map((item) => (
                <div
                  key={item.title}
                  className="rounded-2xl border border-terakkiBorder bg-terakkiBrandCloud px-4 py-3 text-terakkiInk/85 space-y-1"
                >
                  <div className="font-semibold text-terakkiInk">{item.title}</div>
                  <div className="text-sm text-terakkiNeutral">{item.desc}</div>
                </div>
              ))}
            </div>
          </div>

          <section className="pt-6 space-y-4">
            <h2 className="text-xl font-semibold text-terakkiInk">
              Çocuk Güvenliği
            </h2>
            <div className="rounded-2xl border border-terakkiBorder bg-terakkiBrandCloud px-4 py-3 text-terakkiInk/85 space-y-2">
              <p>
                <strong>Terakki</strong> (Adım Adım Terakki) uygulaması, çocuk
                cinsel istismarı ve sömürüsü (CSAE) içeren her türlü içeriği{" "}
                <strong>kesinlikle yasaklar</strong>. Bu tür içeriklerin
                oluşturulması, paylaşılması, depolanması veya dağıtılmasına
                izin verilmez. İhlal tespit edildiğinde hesap derhal
                kapatılacak ve yetkili makamlara bildirim yapılacaktır.
              </p>
            </div>
          </section>

          <section className="pt-6 space-y-4">
            <h2 className="text-xl font-semibold text-terakkiInk">
              Toplanan Veriler
            </h2>
            <ul className="list-disc pl-6 space-y-2 text-terakkiInk/80">
              <li>Hesap bilgileri (ad, e‑posta vb.).</li>
              <li>Uygulama kullanımına ilişkin günlük ve hedef kayıtları.</li>
              <li>Cihaz ve oturum bilgileri.</li>
            </ul>
          </section>

          <section className="pt-6 space-y-4">
            <div className="flex items-start justify-between gap-3 flex-wrap">
              <h2 className="text-xl font-semibold text-terakkiInk">
                Kamera Erişimi
              </h2>
              <span className="inline-flex items-center rounded-full bg-terakkiBrandMist/60 px-3 py-1 text-xs font-semibold text-terakkiInk/75 border border-terakkiBorder">
                Yalnızca QR doğrulama
              </span>
            </div>
            <div className="rounded-2xl border border-terakkiBorder bg-terakkiBrandCloud px-4 py-3 text-terakkiInk/80">
              Kamera yalnızca QR kodu okutarak gruplara katılım için kullanılır.
              Görüntü kaydı tutulmaz, fotoğraf veya video depolanmaz; işlem
              sadece QR doğrulama anında gerçekleşir.
            </div>
          </section>

          <section className="pt-6 space-y-4">
            <h2 className="text-xl font-semibold text-terakkiInk">
              Kullanım Amaçları
            </h2>
            <ul className="list-disc pl-6 space-y-2 text-terakkiInk/80">
              <li>Hizmetin sağlanması ve iyileştirilmesi.</li>
              <li>Güvenlik, hata ayıklama ve performans analizi.</li>
              <li>Hukuki yükümlülüklerin yerine getirilmesi.</li>
            </ul>
          </section>

          <section className="pt-6 space-y-4">
            <h2 className="text-xl font-semibold text-terakkiInk">Paylaşım</h2>
            <p className="text-terakkiInk/80">
              Verileriniz; yasal zorunluluklar veya hizmet sağlayıcılarla
              sözleşmeye bağlı yükümlülükler kapsamında ve gerekli teknik/idari
              tedbirler alınarak paylaşılabilir.
            </p>
          </section>

          <section className="pt-6 space-y-4">
            <h2 className="text-xl font-semibold text-terakkiInk">Haklarınız</h2>
            <p className="text-terakkiInk/80">
              KVKK ve ilgili mevzuat uyarınca verilerinize erişme, düzeltme,
              silme ve işlemeyi kısıtlama gibi haklara sahipsiniz. Talepleriniz
              için bizimle iletişime geçebilirsiniz.
            </p>
          </section>
        </article>
      </section>
    </main>
  );
}
